var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12702"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1885",
    x: 4,
    y: 4,
    width: 4,
    height: 8,
    fill: "#363432",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1888",
    x: 4,
    y: 14,
    width: 4,
    height: 6,
    fill: "#363432",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1886",
    x: 10,
    y: 2,
    width: 4,
    height: 6,
    fill: "#363432",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1889",
    x: 10,
    y: 10,
    width: 4,
    height: 8,
    fill: "#363432",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1887",
    x: 16,
    y: 16,
    width: 4,
    height: 6,
    fill: "#363432",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1890",
    x: 16,
    y: 6,
    width: 4,
    height: 8,
    fill: "#363432",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditsIcon);
export default __webpack_public_path__ + "static/media/edits-icon.8a6c04186c61146ad02f36b1aa7a01d4.svg";
export { ForwardRef as ReactComponent };